import classnames from "classnames";
import {useState} from "react";
import {IoChevronDownOutline, IoChevronUpOutline} from "react-icons/io5";

import {PlanLimit, PlanLimits} from "@/lib/types/accounts.ts";
import {CalculationUnitPrice, Plan} from "@/lib/types/billing.ts";
import {AddonRow} from "@/pages/billing/manage-addons/components/AddonRow.tsx";

import css from "./AddonSection.module.css";
export interface AddonSectionProps {
  title: string;
  subtitle: string;
  fields: string[];
  onChange: (field: string, value: number) => void;
  limits: PlanLimits;
  unitsPrices: CalculationUnitPrice[];
  currentPlan: Plan;
  addedValues: Record<string, number>;
}

export const AddonSection = ({
  title,
  subtitle,
  fields,
  limits,
  unitsPrices,
  currentPlan,
  addedValues,
  onChange,
}: AddonSectionProps) => {
  const [collapsed, setCollapsed] = useState(false);
  return (
    <div className="white-block white-block-border rounded rounded-3 overflow-hidden mt-4">
      <div className={classnames("p-3", css.AddonSectionHeaderBg)}>
        <h2 className={css.AddonSectionHeader}>{title}</h2>
        <span className={css.AddonSectionSubtitle}>{subtitle}</span>
      </div>

      <div style={{overflowX: "auto", WebkitOverflowScrolling: "touch"}}>
        <table className="w-100 mb-0" style={{minWidth: "800px"}}>
          <thead>
            <tr className={css.AddonSectionRow}>
              <th className="p-2 px-3 w-20" onClick={() => setCollapsed(!collapsed)}>
                {collapsed ? <IoChevronDownOutline className="me-2" /> : <IoChevronUpOutline className="me-2" />}
                Features
              </th>
              <th className="p-2 px-3"></th>
              <th className="p-2 px-3 text-center">Used / Included</th>
              <th className="p-2 px-3 text-center">Add Additional</th>
              <th className="p-2 px-3"></th>
              <th className="p-2 px-3 text-center">Monthly Cost</th>
            </tr>
          </thead>

          {!collapsed && limits && (
            <tbody>
              {fields.map((field) => (
                <AddonRow
                  key={field}
                  limit={limits[field as keyof PlanLimits] as PlanLimit}
                  field={field as keyof PlanLimits}
                  onChange={onChange}
                  addedValues={addedValues}
                  currentPlan={currentPlan}
                  unitsPrices={unitsPrices}
                />
              ))}
            </tbody>
          )}
        </table>
      </div>
    </div>
  );
};
